import { Api } from "@/models/base/api";
import { ReqOption } from "@/models/base/api";
// バリデーション用モジュール
import Ajv from "ajv";
import { validationCommon, ValidationResult } from "@/utils/validation-common";
import sysconfig from "@/constants/sysconfig";

export class Model {
  // プロパティは名前: 型
  name: string;
  url: string;
  params: any;
  attributes: any;
  validation: any;
  labels: any;
  reqParams: any;

  constructor(params: any) {
    this.name = "";
    this.url = "";
    this.params = params;
    this.attributes = {};
    if (params && params.id) this.attributes._id = params.id;
    this.validation = null;
    this.labels = null;
    this.reqParams = {};
  }

  // バリデーション前に一時的にフィールドを設定したい場合に使用。
  // モデルによってはupdateTypeなどの設定でも使用。
  set(fields: any): void {
    // 設定したいフィールド情報を上書きマージする
    this.attributes = Object.assign(this.attributes, fields);
  }

  // 取得処理呼び出し
  async fetch(): Promise<any> {
    const reqOption: ReqOption = {
      method: "GET",
      url: this.url,
      params: this.reqParams,
    };
    const api = new Api();
    return await api.fetch(reqOption).then(([response, error]) => {
      if (error) {
        if (sysconfig.common.devmode) {
          console.log("Model fetch error!", this, error);
        }
        return [this, null, error];
      } else {
        this.attributes = response.data;
        if (this.attributes && !this.attributes._id)
          this.attributes._id = this.params.id;
        if (sysconfig.common.devmode) {
          console.log("Model fetch success!", this, response);
        }
        return [this, response, null];
      }
    });
  }

  // 更新処理呼び出し
  async save(fields: any, method: string): Promise<any> {
    // 更新したいフィールド情報をマージする
    const data = Object.assign(this.attributes, fields);
    const reqOption: ReqOption = {
      method: method,
      url: this.url,
      params: this.reqParams,
      data: data,
    };

    const api = new Api();
    return await api.save(reqOption).then(([response, error]) => {
      if (error) {
        if (sysconfig.common.devmode) {
          console.log("Model save error!", this, error);
        }
        return [this, null, error];
      } else {
        // 返却されたフィールド情報をマージする
        this.attributes = Object.assign(this.attributes, response.data);
        if (sysconfig.common.devmode) {
          console.log("Model save success!", this, response);
        }
        return [this, response, null];
      }
    });
  }

  // こちらは使用しない
  // isValid(bool: boolean): any {
  //   const result = this.validate();
  //   if (!(result.valid)) {
  //     return !bool;
  //   }
  //   return bool;
  // }

  // バリデーション処理
  //
  validate(): ValidationResult {
    const result_ajv = this.validate_ajv();
    const result_addon = this.validate_addon();
    const valid = result_ajv.valid && result_addon.valid;
    let errors = [];
    if (!valid) {
      // ajvのエラーと独自チェックエラーをマージ
      errors = result_ajv.errors.concat(result_addon.errors);
      // key一つにつき、最初に返却されたエラー結果のみ返却
      errors = validationCommon.createUniqKeyErrors(errors);
    }
    return validationCommon.createResult(valid, errors);
  }

  // ajvを利用した共通のバリデーション用メソッド
  validate_ajv(): ValidationResult {
    // オプション：{allErrors: true}
    // すべてのエラーを返却する
    const ajv = new Ajv({ allErrors: true });
    // 検証スキーマ作成
    const schema = validationCommon.createSchema(this.validation);
    // バリデーション関数を作成
    const validateFunc = ajv.compile(schema);
    // バリデーションを実行
    const valid = validateFunc(this.attributes);

    const errors = [];
    if (!valid && validateFunc.errors && validateFunc.errors.length) {
      // console.log(validateFunc.errors);
      // バリデーションエラー
      for (const obj of validateFunc.errors) {
        errors.push(validationCommon.convertAjvError(obj, this));
      }
    }

    return validationCommon.createResult(valid, errors);
  }

  // 独自のバリデーション処理（各モデル内でオーバーライドする）
  validate_addon(): ValidationResult {
    // 以下、記述例

    // チェックしたい項目、チェック処理をこちらに記載していく
    // const errors = [];
    // // 独自チェックを持つ項目リスト作成
    // const list = validationCommon.getAddonList(this.validation);

    // // 各項目でチェック処理を行う
    // for( const obj of list){
    //   // noHalfSpace
    //   if (obj.value.addOn.noHalfSpace !== undefined) {
    //     const noHalfSpace_error = validationCommon.addOnFunc.noHalfSpace(this.attributes[obj.key], obj.key, obj.value.addOn.noHalfSpace, this);
    //     if (noHalfSpace_error){
    //       errors.push(noHalfSpace_error)
    //     }
    //   }
    //   // 他に必要な場合は下に追加していく
    //   //
    // }

    // const valid = errors.length ? false : true;
    // // 返却情報の作成
    // return validationCommon.createResult(valid, errors);

    // 記述例ここまで

    // 返却情報の作成
    return validationCommon.createResult(true, []);
  }
}
